<template>
  <vue-draggable-resizable
    :w="width"
    :h="height"
    :x="posX"
    :y="posY"
    :active="true"
    :parent="true"
    :resizable="true"
    @resizing="onResizing"
    :max-height="700"
    :max-width="1000"
    :min-width="656"
    class="home-form-container elevation-2"
    :style="{ height: height }"
    class-name-handle="object-form-resizable-handle"
    :drag-handle="'.drag'"
    data-app
  >
    <div ref="objectForm">
      <form-header
      :title="pageTitle"
      @close="tryCloseForm">

        <form-options-menu
          :action-type="action"
          v-if="userHasFibercloudPermission('workorder', 'edit')"
          :workorder-form="true"
          @clearData="$emit('clearData')"
          @changeViewModeOfObject="changeViewModeOfObject"
          @refresh="refresh"
        />
      </form-header>
      <v-tabs v-model="tab" background-color="transparent" color="accent">
        <v-tab
          v-for="item in tabs"
          :key="item.tab"
          style="text-transform: none; font-size: 12px;"
          :disabled="item.disabled"
        >
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabs" :key="item.tab">
          <component
            :is="item.content"
            v-if="!loading"
            :receivedData="receivedData"
            @objectTemplates="objectTemplates"
            :disabledView="disabledView"
            :actionType="action"
            :startDate="receivedData.start_date"
          />

          <div
            v-else
            style="background-color: #F0F0EF; height: 535px; overflow: auto"
            class="d-flex align-center justify-center"
          >
            <v-progress-circular
              :size="100"
              :width="5"
              color="accent"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <v-row class="d-flex justify-space-between mr-3 mb-3">
      <v-btn
          @click="getWorkOrderToExport"
          color="accent"
          class="footer-button  ml-6"
          :loading="exportLoading"
          :disabled="hasExportPermissions"
        >
        {{ $t("Export") }}
      </v-btn>
      <div>
        <v-btn
          @click="previousButton"
          text
          :disabled="tab === 0"
          color="var(&#45;&#45;secondary-darker)"
          class="footer-button  mr-2"
        >
          {{ $t("Previous") }}
        </v-btn>

        <v-btn
          v-if="tab !== 3"
          @click="nextButtonJumpToSummary"
          color="accent"
          class="footer-button mr-3"
          :disabled="nextButton"
        >
          {{ $t("Next") }}
        </v-btn>

        <v-btn
          @click="saveWorkOrder"
          color="accent"
          class="footer-button mr-3"
          :disabled="disabledView"
          v-if="tab === 3"
        >
          {{ $t("Save") }}
        </v-btn>
      </div>
    </v-row>
  </vue-draggable-resizable>
</template>

<script>
import WindowHeaderButton from "../../../_Atoms/WindowHeaderButton";
import AppDialogBox from "../../../_Molecules/AppDialogBox";
import FormOptionsMenu from "../_Atoms/FormOptionsMenu.vue";
import FormHeader from "@/components/Home/Forms/_Molecules/FormHeader";
import WorkOrderDetails from "./WorkOrderDetails.vue";
import WorkOrderAssignment from "./WorkOrderAssignment.vue";
import WorkOrderSchedule from "./WorkOrderSchedule.vue";
import WorkOrderSummary from "./WorkOrderSummary.vue";
import { checkPermissionsMixin } from "../../../../mixins/checkPermissionsMixin";
import { activitiesTasksDataMixin } from "../../../../mixins/field/activitiesTasksDataMixin";
import { mapActions } from "vuex";

export default {
  name: "WorkOrderForm",

  mixins: [activitiesTasksDataMixin, checkPermissionsMixin],

  components: {
    AppDialogBox,
    WindowHeaderButton,
    FormHeader,
    WorkOrderDetails,
    WorkOrderAssignment,
    WorkOrderSchedule,
    WorkOrderSummary,
    FormOptionsMenu
  },
  props: {
    actionType: {
      type: String
    },
    workOrder_uuid: {
      type: String
    }
  },

  data() {
    return {
      posY: undefined,
      posX: undefined,
      width: 700,
      height: 400,
      wasResized: false,
      openTab: "details",
      tab: null,
      priorities: null,
      disableTabs: false,
      workorderName: null,
      action: this.actionType,
      receivedData: {
        activities: [],
        label: null,
        start_date: null,
        end_date: null,
        priority: null,
        geom: null
      },
      exportLoading: false,
    };
  },

  computed: {
    /**
     * returns text geom from drawn polygon
     */
    textGeom() {
      return this.$store.state.object.multiObjectSelection.polygon;
    },

    /**
     * appears view mode
     */
    pageTitle() {
      let title = this.$t('WorkOrder');
      let objectIdentifier = null;
      if(this.action !== 'create'){
        objectIdentifier = this.receivedData.label
      }
      if (objectIdentifier !== null) {
        title += ' - ' + objectIdentifier;
      }
      if(this.action === 'view'){
        title += ' - View Mode';
      }
      return title;
    },

    /**
     * Tabs used in the form  with the respective components
     */
    tabs() {
      return [
        {
          tab: this.$tc("Detail", 2),
          content: WorkOrderDetails,
          disabled: false
        },
        {
          tab: this.$tc("Assignments"),
          content: WorkOrderAssignment,
          disabled: this.assignmentDisable
        },
        {
          tab: this.$tc("Schedule"),
          content: WorkOrderSchedule,
          disabled: this.scheduleDisable
        },
        {
          tab: this.$tc("Summary"),
          content: WorkOrderSummary,
          disabled: this.summaryDisable
        }
      ];
    },
    hasExportPermissions(){
      const show_Workorder_permission = this.userHasPermission("workorder", "fibercloud_web","show");
      const create_export_permission = this.userHasPermission("export", "management","store");
      return !(show_Workorder_permission && create_export_permission);
    },
    /**
     * disables assignment tab if fields are not filled
     */
    assignmentDisable() {
      return (
        this.receivedData.activities.length === 0 ||
        !this.receivedData.label ||
        !this.receivedData.end_date ||
        !this.receivedData.start_date ||
        !this.receivedData.priority
      );
    },
    /**
     * disables button depending on disabled tabs
     */
    nextButton() {
      if (this.tab === 0) {
        return this.assignmentDisable;
      }
      if (this.tab === 1) {
        return this.scheduleDisable && this.summaryDisable;
      }
      if (this.tab === 2) {
        return this.summaryDisable;
      }
    },
    /**
     * enables summary when all tasks have a scheduled date or a company is selected in all activities
     */
    summaryDisable() {
      let found = true;
      this.receivedData.activities.forEach(item => {
        if (item.company && item.company.length > 0) {
          found = item.company.some(elem => !elem.id);
        } else {
          found = item.tasks.some(item => !item.user_assignee_id);
        }
      });
      return found;
    },
    /**
     * enables schedule when an activitiy has a task with a user assigned
     */
    scheduleDisable() {
      let found = true;

      this.receivedData.activities.forEach(item => {
        item.tasks.forEach(item => {
          if (item.user_assignee_id) {
            found = false;
          }
        });
      });

      return found;
    },
    /**
     * disables fields when in view mode
     */
    disabledView() {
      return this.action === "view";
    },
  },
  /**
   * when component is created, if there is an actiontype, getworkorder request is executed
   */
  created() {
    if (this.action === "view" || this.action === "edit") {
      this.getWorkOrder(this.workOrder_uuid);
    }
  },
  /**
   * fetches all users for assignment later and, sets initialposition of form on screen
   */
  mounted() {
    this.loadAllUsers();
    this.fetchUserCompanies();
    this.$nextTick(() => {
      // Sets the initial position of the form (centers it)
      this.setInitialPosition();
    });
  },

  methods: {
    ...mapActions([
      "createWorkOrder",
      "exportWorkOrder",
      "sendBulkActivities",
      "priorityLists",
      "getWorkOrderByUUID",
      "resetselectedTemplateState",
      "updateBulkActivities",
      "updateWorkOrder"
    ]),
    onResizing(left, top, width, height) {
      this.height = height;
      this.width = width;
      this.wasResized = true;
    },
    /**
     * populates array of activities with the filled templates from templateDetails component
     */
    objectTemplates(value) {
      value.forEach(item => {
        this.receivedData.activities.push(item);
      });
    },
    /**
     * gets previously created workorder,
     * it then creates a set with each template title and commits to the store (title is used on left side of activities to populate the activities
     * from that template)
     * in each task a color is added according to the state
     * the uuid is inserted in a id (unique) property so it is later used in the schedule when moving dates.
     * start and end are required params for the vuetify calendar therefore, a calculation is done from the start to end date, timed is required also.
     * all other properties are the workorder properties
     * a geom is saved to be used if user wants to add another template and when saving.
     *
     */
    async getWorkOrder(uuid) {
      try {
        this.loading = true;
        let activities = await this.getWorkOrderByUUID(uuid);
        let template = new Set();
        activities.activities.forEach(item => {
          item.company = [];

          template.add(JSON.stringify({ title: item.title }));
          const formattedSet = [...template].map(item => {
            if (typeof item === "string") return JSON.parse(item);
            else if (typeof item === "object") return item;
          });
          this.$store.commit("selectedTemplates", formattedSet);
          item.tasks.forEach(task => {
            if (
              task.state === "created" ||
              task.state === "scheduled" ||
              task.state === "company_assign"
            ) {
              task.color = "#9da7ad";
            } else if (
              task.state === "completed" ||
              task.state === "approved"
            ) {
              task.color = "#38f033";
            } else if (task.state === "pending_approval") {
              task.color = "#ffb429";
            } else if (task.state === "blocked") {
              task.color = "#ff3d3b";
            } else if (task.state === "in_progress") {
              task.color = "#00cbfd";
            } else if (task.state === "reopened") {
              task.color = "#fee94e";
            }
            task.id = task.uuid;

            task.name = task.title;

            task.start = new Date(task.scheduled_date).getTime();
            task.end = task.start + task.execution_time * 60000;
            task.timed = true;
          });
        });
        this.receivedData.activities = activities.activities;
        this.receivedData.label = activities.name;
        this.workorderName = activities.name;
        this.receivedData.start_date = activities.start_date.substring(0, 10);
        this.receivedData.end_date = activities.end_date.substring(0, 10);
        this.receivedData.priority = activities.priority;
        this.receivedData.geom = activities.text_geom;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    /**
     * when saving a workorder, two requests are made, one to create the workorder and one to send the bulk of activities.
     * the scheduled time is updated when the content is saved, v-calendar was not updating the time correctly when in 24:00 mode.
     *
     *
     */
    async saveWorkOrder() {
      let dataToSend ;
      
      if(this.action === "edit"){
        dataToSend = {
          name: this.receivedData.label,
          workspace_uuid: sessionStorage.getItem("workspace_uuid"),
          priority_uuid: this.receivedData.priority.uuid,
          start_date: this.receivedData.start_date,
          end_date: this.receivedData.end_date
        };
      }else{
        dataToSend = {
          name: this.receivedData.label,
          geom: this.textGeom || this.receivedData.geom,
          workspace_uuid: sessionStorage.getItem("workspace_uuid"),
          priority_uuid: this.receivedData.priority.uuid,
          start_date: this.receivedData.start_date,
          end_date: this.receivedData.end_date
        };
      }

      if (this.workorderName === this.receivedData.label) {
        delete dataToSend.name;
      }
      if (this.action === "edit") {
        try {
          this.loading = true;
          this.receivedData.activities.forEach(item => {
            delete item.company;
            delete item.id;
            delete item.label;

            item.tasks.forEach(item => {
              if (item.scheduled_date) {
                item.scheduled_date = this.getDateTime(item.scheduled_date);
              }
            });
          });
          await this.updateWorkOrder({
            data: dataToSend,
            uuid: this.workOrder_uuid
          });

          const activitiesWithDate = this.receivedData.activities.map(activity => {
            if (!activity.due_date) {
              activity.due_date = this.receivedData.end_date;
            } else if (activity.due_date <= this.receivedData.end_date) {
              activity.due_date = this.receivedData.end_date;
            }
            return activity;
          });

          await this.updateBulkActivities({
            activities: activitiesWithDate,
            uuid: this.workOrder_uuid
          });

          this.tryCloseForm();
          this.$emit("update-geoserver");
        } catch (error) {
          this.$toasted.global.toast_error(
            error.response.data.message +
              " " +
              this.$i18n.tc("MissingFieldsWorkOrder")
          );
        } finally {
          this.loading = false;
          this.$toasted.global.toast_success(
            this.$i18n.tc("WorkorderEditedSuccess")
          );
        }
      } else {
        this.loading = true;
        try {
          this.receivedData.activities.forEach(item => {
            delete item.company;
            delete item.id;
            delete item.label;

            item.tasks.forEach(item => {
              if (item.scheduled_date) {
                let time = new Date(item.scheduled_date);
                time.setHours(time.getHours() + 1);
                time
                  .toISOString()
                  .replace("T", " ")
                  .substr(0, 19);
                item.scheduled_date = time;
              }

              item.content.forEach(item => {
                delete item.uuid;
              });
            });
          });

          let workorder = await this.createWorkOrder(dataToSend);

          const activitiesWithDate = this.receivedData.activities.map(activity => {
            activity.due_date = this.receivedData.end_date;
            return activity;
          });

          await this.sendBulkActivities({
            activities: activitiesWithDate,
            uuid: workorder.uuid
          });

          this.tryCloseForm();
          this.$emit("update-geoserver");
        } catch (error) {
          console.log(error.response.data.message);
          this.$toasted.global.toast_error(
            error.response.data.message +
              " " +
              this.$i18n.tc("MissingFieldsWorkOrder")
          );
        } finally {
          this.loading = false;
          this.$toasted.global.toast_success(
            this.$i18n.tc("WorkorderCreatedSuccess")
          );
        }
      }
    },
    async getWorkOrderToExport(){
      try{
        this.exportLoading = true;
        let workorder = await this.exportWorkOrder(this.workOrder_uuid);
        const blob = new Blob([workorder], { type: 'application/zip'});
        const FILE = window.URL.createObjectURL(blob);
        const docUrl = document.createElement('a');
        docUrl.href = FILE;
        docUrl.setAttribute('download', `${this.workorderName}.zip`);
        document.body.appendChild(docUrl);
        docUrl.click();
      }catch(error){
        this.$toasted.global.toast_error(error.response.data.message);
      }finally{
        this.exportLoading = false;
      }
    },
    /**
     * if schedule is disabled next button jumps to summary (if there are only companies assigned)
     */
    nextButtonJumpToSummary() {
      if (this.scheduleDisable && !this.summaryDisable && this.tab === 1) {
        this.tab = 3;
      } else {
        this.tab += 1;
      }
    },
    /**
     * previous button when schedule is disabled it jumps to assigment tab
     */
    previousButton() {
      if (this.scheduleDisable && !this.summaryDisable && this.tab !== 1) {
        this.tab = 1;
      } else {
        this.tab -= 1;
      }
    },
    /**
     * changes the mode from view to edit or viceversa
     */
    changeViewModeOfObject(view) {
      this.action = view;
    },

    /**
     * Defines the initial position of the current component.
     */
    setInitialPosition() {
      let mapElement = this.$parent.$refs.map;
      this.posX = Math.round((mapElement.offsetWidth - this.width) / 2);
      this.posY = Math.round(0);
    },
    /**
     * closes form and clears vuex store
     */
    tryCloseForm() {
      this.closeForm();
      this.resetselectedTemplateState();
    },

    /** Emits an event to close this component's window **/
    closeForm() {
      this.$store.dispatch("CLEAR_MULTI_OBJECT_SELECTION_DATA");
      this.$emit("closeForm");
    },
     refresh(){
      this.getWorkOrder(this.workOrder_uuid);
    },
  }
};
</script>

<style scoped>
.home-form-container {
  min-width: 500px !important;
  z-index: 150 !important;
}
.home-form-container >>> input[type="text"]:not(.vue-treeselect__input) {
  background-color: transparent !important;
}
.home-form-container .footer-button {
  font-size: 8px;
  height: 22px !important;
  min-width: 70px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/WorkOrderForm.vue